<template>
  <MobileActionsMenu
    :model-value="modelValue"
    title="Votre compte"
    primary-text="Se déconnecter"
    primary-danger
    @update:model-value="$emit('update:modelValue', $event)"
    @primary="handleLogout"
  >
    <div class="user-menu__profile">
      <div class="user-menu__avatar">
        <Icon name="user" :size="32" />
      </div>
      <div class="user-menu__info">
        <div class="user-menu__name">{{ displayName }}</div>
        <div class="user-menu__email">{{ user?.email }}</div>
      </div>
    </div>
  </MobileActionsMenu>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import MobileActionsMenu from '@/components/menu/MobileActionsMenu.vue'
import Icon from '@/components/icons/Icon.vue'

defineProps<{
  modelValue: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const router = useRouter()
const authStore = useAuthStore()
const user = computed(() => authStore.user)
const displayName = computed(() => {
  if (!user.value) return ''
  return user.value.user_metadata?.full_name || user.value.email || ''
})

const handleLogout = async () => {
  try {
    await authStore.logout()
  } finally {
    emit('update:modelValue', false)
    router.push({ name: 'login' })
  }
}
</script>

<style scoped>
.user-menu__profile {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem 1rem;
}

.user-menu__avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--layout-surface-variant);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-menu__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.user-menu__name {
  color: var(--text-defaut);
  font-weight: 600;
  font-size: 1rem;
  font-family: Outfit, sans-serif;
}

.user-menu__email {
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin-top: 0.25rem;
  font-family: Rubik, sans-serif;
  overflow-wrap: anywhere;
}
</style>
